<div fxLayout="column" fxLayoutWrap="wrap">
    <div style="margin: 20px 0 0 0;" fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
        <span>Turno Ausente</span>
    </div>
    <div style="margin: 10px 0 0 0;" fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
        <mat-form-field fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
            <textarea matInput [placeholder]="'Motivo'" rows="3" [(ngModel)]="local_data.absentNote"></textarea>
        </mat-form-field>
    </div>
    <div style="margin: 20px 0 0 0; text-align: right;" fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
        <button (click)="closeDialog()" mat-button color="primary">Cancelar</button>
        <button (click)="doAction()" mat-raised-button color="warn">Aceptar</button>
    </div>
</div>